module.exports = __webpack_public_path__ + "static/media/edit.11fba52b.svg";